"use client";

import { useBrandingStore } from "@/zustand/brandingStore";

/**
 * Accent color for header components.
 * Prefers page-level accent (event wall/checkout/thank-you), then store branding.
 */
export function useHeaderAccentColor() {
  const pageAccentColor = useBrandingStore((s) => s.pageAccentColor);
  const overridePrimary = useBrandingStore((s) => s.overrides.primaryColor);
  const currentPrimary = useBrandingStore((s) => s.current?.primaryColor);
  const accentColor =
    pageAccentColor || overridePrimary || currentPrimary || null;
  const hasEventAccent = !!pageAccentColor;

  if (!accentColor) {
    return {
      accentColor: null,
      hasEventAccent: false,
      textStyle: {},
      bgStyle: {},
      borderStyle: {},
    };
  }

  return {
    accentColor,
    hasEventAccent,
    textStyle: { color: accentColor },
    bgStyle: { backgroundColor: accentColor },
    borderStyle: { borderColor: accentColor },
  };
}
